import { DateUtils } from '@web_opxp/features';

export function formatDateToString(date: number | string | Date, language?: string) {
  return DateUtils.formatDate(date, { dateStyle: 'long' }, language);
}
